/** @jsx h */
import { FunctionalComponent, h } from 'preact';
import { useCallback } from 'preact/hooks';
import { SupportedEvents } from '../../../../enums/event';
import { IItemModel } from '../../../../models/Item';
import { IMenuItemModel } from '../../../../models/Menu';
import { useEventHandler } from '../../../../providers/eventHandlerProvider';
import { FOOTER_ID_MANAGE_COOKIES } from '../../../../utils/constants';
import { FooterItem } from '../footerLink/footerLinkStyled';
import AppLink from '../../../appLink';

export interface IManageCookiesProps {
  item: IMenuItemModel;
}

const ManageCookiesLink: FunctionalComponent<IManageCookiesProps> = ({ item }) => {
  const itemModel = item as IItemModel;
  const { anchorText } = itemModel;
  const { dispatchEvent } = useEventHandler();

  const handleLinkClick = useCallback(
    (event: Event) => {
      event.preventDefault();
      dispatchEvent(SupportedEvents.onManageCookiesClick);
    },
    [dispatchEvent],
  );

  return (
    <FooterItem>
      <AppLink item={itemModel} onClick={handleLinkClick} id={FOOTER_ID_MANAGE_COOKIES}>
        {anchorText}
      </AppLink>
    </FooterItem>
  );
};

export default ManageCookiesLink;
